import React from 'react';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { TrainerFormValues } from 'src/models/Trainer.model';
import TrainerForm from '../Layouts/TrainerForm';
import SideNavLayout from 'src/components/layouts/SideNavLayout/SideNavLayout';
import { useAddTrainerMutation } from 'src/services/TrainerServices';
import { showToast } from 'src/utils/showToaster';
import { useNavigate } from 'react-router-dom';
import { mobileRegExp } from 'src/utils/validations/indianPhoneRegex';

const AddTrainerFormWrapper = () => {

    const [addTriner] = useAddTrainerMutation()
    const navigate = useNavigate()

    // Form Initial Values
    const initialValues: TrainerFormValues = {
        trainer_name: '',
        mobile_number: '',
        whatsapp_number: '',
        password:'',
        emergency_contact_number: '',
        dob: null,
        email: '',
        marital: '',
        gender: '',
        address: '',
        blood_group: '',
        branchId:[],
        academic_history: [
            {
                collge_school_name: '',
                course_name: '',
                course_type: '',
                collge_school_tier: '',
                start_year: '',
                end_year: '',
                currently_pursuing: false,
            }
        ],
        work_history: [
            {
                company_name: "",
                job_description: "",
                job_title: "",
                end_year: "",
                start_year: "",
                currently_pursuing: false,

            }
        ]
    };

    // Validation Schema
    const validationSchema = object().shape({ 
        mobile_number:  string()
        .trim()
        .matches(mobileRegExp, "mobile number is not valid"),
        whatsapp_number:  string()
        .trim()
        .matches(mobileRegExp, "mobile number is not valid"),
        emergency_contact_number:  string()
        .trim()
        .matches(mobileRegExp, "mobile number is not valid"),
        password:string().trim().required('password is required') ,
        email: string()
            .required('Please enter email')
            .email('Invalid email'),

        trainer_name: string().required('Please enter name'),
        address: string().required('Please enter address'),

        dob: string().required('Please enter date of birth'),
    });

    // Handle Submit
    const handleSubmit = (
        values: TrainerFormValues,
        { setSubmitting, resetForm }: FormikHelpers<TrainerFormValues>
    ) => { 
         
   // Step 1: Remove the country code if present
   const withoutCountryCode = values?.mobile_number?.replace(/^\+91\s?/, "");

   // Step 2: Remove all spaces
   const finalNumber = withoutCountryCode?.replace(/\s/g, "");

        const formattedValues = {
            name: values?.trainer_name,
            email: values?.email,
            mobile: finalNumber,
            altMobile: values?.trainer_name,
            whatsappMobileNo: values?.whatsapp_number,
            emergencyContactNo: values?.emergency_contact_number,
            branchId: values?.branchId?.map((branch) => branch?.value),
            address: values?.address,
            password : values?.password ,
            gender: values?.gender,
            dob: values?.dob,
            maritalStatus: values?.marital,
            academicHistory: values?.academic_history?.map((el: any) => {
                return {
                    collge_school_name: el?.collge_school_name,
                    course_name: el?.course_name,
                    course_type: el?.course_type,
                    collge_school_tier: el?.collge_school_tier,
                    start_year: el?.start_year || "",
                    end_year: el?.end_year || "",
                    currently_pursuing: el?.currently_pursuing,
                };
            }),
            workExperience: values?.work_history?.map((el: any) => {
                return {
                    company_name: el?.company_name,
                    job_title: el?.job_title,
                    job_description: el?.job_description,
                    start_year: el?.start_year || "",
                    end_year: el?.end_year || "",
                    currently_pursuing: el?.currently_pursuing,
                };
            }),
            bloodGroup: values?.blood_group
        }
        addTriner(formattedValues).then((res: any) => {
            if (res?.error) {
                showToast('error', res?.error?.data?.message);
            } else {
                if (res?.data?.status) {
                    showToast('success', res?.data?.message);
                    resetForm();
                    navigate('/trainer')
                } else {
                    showToast('error', res?.data?.message);
                }
            }
            setSubmitting(false);
        });
    };

    return (
        <SideNavLayout >
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {(formikProps) => (
                    <Form>
                        <TrainerForm formikProps={formikProps} />
                    </Form>
                )}
            </Formik>
        </SideNavLayout>
    );
};

export default AddTrainerFormWrapper;